import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { InputLabel } from 'ui';

import s from './Select.module.scss';

const cx = cn.bind(s);

const Select = ({
  className, label, error, onChange, options, value, ...attrs
}) => {
  const selectClassName = cx('select', { error });
  return (
    <InputLabel className={className} error={error} text={label}>
      <select
        className={selectClassName}
        value={value || ''}
        onChange={onChange}
        {...attrs}
      >
        {Array.isArray(options) ? (
          <>
            <option hidden value=""></option>
            {options.map(({ value: optionValue, label: optionLabel }) => (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            ))}
          </>
        ) : (
          Object.keys(options).map((group) => (
            <optgroup key={group} label={group}>
              <option hidden value=""></option>
              {options[group].map?.(({ value: optionValue, label: optionLabel }) => (
                <option key={optionValue} value={optionValue}>
                  {optionLabel}
                </option>
              ))}
            </optgroup>
          ))
        )}
      </select>
    </InputLabel>
  );
};

const optionsType = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
);

Select.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  options: PropTypes.oneOfType([optionsType, PropTypes.objectOf(optionsType)]),
  value: PropTypes.string,
  onChange: PropTypes.func,
};

Select.defaultProps = {
  label: '',
  error: '',
  options: [],
  className: '',
  value: '',
  onChange: () => {},
};

export default Select;
